// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-modal-container',
    computed: {
        modalWindows: function () {
            return this.$host.store.get("windows").modalWindows;
        },
    },
});
// #endregion
